// extracted by mini-css-extract-plugin
export default {"graphicPromo":"GraphicPromoFallbackCard_graphicPromo__NmQ4Y"};